import { snakeStore, SORT_COLUMN, SORT_DIRECTION } from '@app/plugins/vuex-async-pagginate';
import { StatsService } from '@autoinformer/services/StatsService';

export const table = snakeStore(
  {
    state: {
      [SORT_COLUMN]: 'call_date',
      [SORT_DIRECTION]: 'desc'
    },
    actions: {
      getData: (_, params) => StatsService.getListExtend(params)
    }
  },
  true
);
